const versions = [
  { ver: "5.2.1", date: "2026-08-30", notes: ["修复部分机型通知不生效问题", "优化首页刷新速度，加载更快", "新增专题收藏的云端同步"] },
  { ver: "5.2.0", date: "2026-08-12", notes: ["上线关键词追踪推送", "改进夜间阅读模式，护眼更舒适", "修复少量闪退问题"] },
  { ver: "5.1.6", date: "2026-07-25", notes: ["调整热榜排序逻辑更贴合兴趣", "优化包体体积，安装更省空间"] },
  { ver: "5.1.0", date: "2026-07-02", notes: ["新增专题时间线合集", "完善来源标注与信息筛选"] },
];

export default function VersionLog() {
  return (
    <section id="version" className="w-full border-y border-background-200 bg-background-100/70 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-12">
          <div>
            <span className="inline-flex items-center rounded-full bg-secondary-100 px-3 py-1 text-xs font-bold text-secondary-800">
              版本更新
            </span>
            <h2 className="mt-4 font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              吃瓜神器最新版动态
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              我们会持续优化体验并定期推送新版本。在手机设置中开启「自动更新」，或回到本页下载最新安装包即可第一时间用上新功能。
            </p>

            <div className="mt-6 flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                <i className="ri-android-line text-2xl"></i>
              </span>
              <div>
                <p className="font-heading text-sm font-bold text-foreground-950">当前最新版本</p>
                <p className="text-2xl font-black text-accent-600">v5.2.1</p>
              </div>
            </div>
          </div>

          <div className="relative flex flex-col gap-4 pl-6">
            <div className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300"></div>
            {versions.map((v) => (
              <div key={v.ver} className="relative">
                <span className="absolute -left-6 top-1.5 h-3.5 w-3.5 rounded-full border-2 border-background-50 bg-accent-500"></span>
                <div className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <div className="flex flex-wrap items-center gap-3">
                    <h3 className="font-heading text-base font-bold text-foreground-950">v{v.ver}</h3>
                    <span className="text-xs text-foreground-600">发布于 {v.date}</span>
                  </div>
                  <ul className="mt-3 flex flex-col gap-1.5">
                    {v.notes.map((n) => (
                      <li key={n} className="flex items-start gap-2 text-sm text-foreground-700">
                        <i className="ri-check-line mt-0.5 shrink-0 text-accent-600"></i>
                        {n}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}